import React from "react";
import styled from "styled-components";
import Components from "../../components";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { AuthForm, Width } = Components;

const COMPANY_NAME = "Freedom Finance Armenia LLC";
const CERTIFICATE_CN = "*.partners.ffin.am";

const FirstBlock = styled.div`
  width: 100%;
  padding: 80px 0px;
  border-bottom: 1px solid #d1d3d4;

  & > div {
    display: flex;
  }
`;

const BTitile = styled.div`
  white-space: pre-line;
  font-weight: 500;
  font-size: 32px;
  line-height: 110%;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 1fr));
  gap: 40px;
  margin-inline-start: 30px;
`;

const ContentIn = styled.div`
  display: flex;
  align-items: self-start;
`;

const WelcomeAmPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("welcome.metaTitle")} - AM</title>
        <meta
          name="description"
          content={`${t("welcome.metaDescription")} AM`}
        />
        <link rel="icon" href="/images/am/favicon.ico" />
      </Helmet>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.loginTitle")}</BTitile>
          <Content>
            <ContentIn>
              <AuthForm />
            </ContentIn>
            <ContentIn>
              {t("welcome.newCabinetNoticePartner", { company: COMPANY_NAME })}
            </ContentIn>
          </Content>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.partnersTitle")}</BTitile>
          <Content>
            <ContentIn>
              <div>
                {t("welcome.securityCertificate")} <b>CN = {CERTIFICATE_CN}</b>
              </div>
            </ContentIn>
            <ContentIn>{t("welcome.passwordWarning")}</ContentIn>
            <ContentIn>{t("welcome.emailAccessWarning")}</ContentIn>
            <ContentIn>{t("welcome.fraudWarning")}</ContentIn>
          </Content>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.documents")}</BTitile>
        </Width>
      </FirstBlock>
    </>
  );
};

export default WelcomeAmPage;
